import { getSelectedCategoryName } from '../helpers/get-selected-category-name.js';

function initializeEventTime() {
	const categoryName = getSelectedCategoryName(this.formElement);

	const labelElement = this.currentStepElement.querySelector('label[for="quote-request-event-time"]');
	if (categoryName) {
		// Store original label text in a data attribute in case we
		// need it later.
		labelElement.dataset.originalText = labelElement.textContent;
		// Update label text to rephrase our question and use the
		// chosen category name.
		labelElement.textContent = `What time should your ${categoryName} start?`;
	} else if (labelElement.dataset.originalText) {
		// Reset the label text if we have a data attribute. This seems
		// like a strange case but if somehow we don't have category
		// text after going back and forth in the process we want this
		// label to still make sense by using its original copy.
		labelElement.textContent = labelElement.dataset.originalText;
	}
}

export {
	initializeEventTime
}